type DisplayItemLike = {
  price?: string | null
  marketPrice?: string | null
  image?: string | null
}

export function sortDisplayItemsByPrice<T extends DisplayItemLike>(items: T[]): T[] {
  return items.slice().sort((a, b) => {
    const pa = BigInt(a.price ?? a.marketPrice ?? 0)
    const pb = BigInt(b.price ?? b.marketPrice ?? 0)
    return pb > pa ? 1 : pb < pa ? -1 : 0
  })
}

export function getTopDisplayItemImage(
  items: DisplayItemLike[] | null | undefined,
  fallback = '',
): string {
  if (!items?.length) return fallback
  return sortDisplayItemsByPrice(items)[0]?.image ?? fallback
}
